import React from "react";
import SkeletonElement from "../../Category/Shimmer/SkeletonElement";

/*
  The shared table-loading shimmer (17 consumers across Products, Mapping, ARS,
  ISR, ABTesting, CategoryRelevancy, CBM, DeltaTable…). Re-inked onto role
  tokens 2026-09-06: the bars were already DS Skeleton (category Phase 1), but
  this wrapper still painted its header/rows with inline #f2f2f2/#FFFFFF and
  the bootstrap `.table` class — so in dark mode every consumer showed white
  bands under dark-theme bars. Same DOM shape and geometry as before; only the
  grounds moved to tokens. Purely presentational — no props, no state.
*/
const HEADER_CELL_STYLE = {
  position: "sticky",
  left: "0px",
  height: "43px",
  fontFamily: "Noto Sans",
  fontWeight: 400,
  padding: "13px 31px 11px 20px",
  textTransform: "uppercase",
};

const BODY_CELL_STYLE = {
  position: "sticky",
  left: "0px",
  height: "43px",
  fontFamily: "Noto Sans",
  fontWeight: 400,
  padding: "13px 31px 11px 20px",
};

const COLUMNS = [0, 1, 2, 3];

const TableSkeletonElement = () => {
  return (
    <table
      id="table-skeleton"
      className="tw-w-full tw-whitespace-nowrap tw-border tw-border-edge"
      style={{ tableLayout: "auto !important" }}
    >
      <thead className="tw-sticky tw-top-0 tw-bg-surface-sunken">
        <tr className="tw-border tw-border-edge">
          {COLUMNS.map((col) => (
            <th
              key={col}
              width="200px"
              className="tw-border-0 tw-bg-surface-sunken"
              style={HEADER_CELL_STYLE}
            >
              <SkeletonElement type="title" />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {[111, 112, 113, 114, 115].map((product, singleProductindex) => (
          <tr key={singleProductindex} className="tw-border-b tw-border-edge">
            {COLUMNS.map((col) => (
              <th
                key={col}
                width="30%"
                className="tw-align-middle tw-bg-surface"
                style={BODY_CELL_STYLE}
                title={""}
              >
                <SkeletonElement type="text" />
              </th>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
export default TableSkeletonElement;
